import React from 'react';
import TooltipComponent from '../Tooltip/TooltipComponent';
import styles from '../ButtonGroup/ButtonGroup.module.scss';

interface MultipleButtonsProps {
  buttons: {
    id: string;
    value?: string;
    label: string;
    checked?: boolean;
    disabled?: boolean;
    disabledMsg?: string;
    dataTestId?: string;
  }[];
  onClickAction?: (id: string) => void; // eslint-disable-line no-unused-vars
  bigMode?: boolean;
}

const MultipleButtons: React.FC<MultipleButtonsProps> = (props) => {
  const { buttons, onClickAction = () => {}, bigMode = false } = props;

  const buttonsNodes = buttons.map((button) => (
    <label htmlFor={button.id} key={button.id}>
      <input
        type="radio"
        disabled={button?.disabled || false}
        value={button?.value || button?.id}
        id={button.id}
        data-testid={button.dataTestId || button.id}
        checked={button?.checked}
        onChange={() => onClickAction(button?.id)}
      /><span>{button?.label}</span>
    </label>
  ));

  return (
    <div className={`${styles.ButtonGroup} ${bigMode ? styles.ButtonGroupBig : ''}`}>
      { buttonsNodes.map((button, index) => (
        buttons[index].disabled && buttons[index].disabledMsg
          ? <TooltipComponent title={buttons[index].disabledMsg || ''}>{button}</TooltipComponent>
          : button
      ))}
    </div>
  );
};

export default MultipleButtons;
